import { Field, Checkbox as HeadlessCheckbox, Label } from "@headlessui/react";
import { ComponentProps, ReactNode } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import Error from "./error";
const sizes = {
    base: "size-5 min-h-5 min-w-5",
    sm: "size-4 min-h-4 min-w-4",
};

const colors = {
    black: "data-checked:bg-black hover:border-black data-checked:border-black",
    voice: "data-checked:bg-voice hover:border-voice data-checked:border-voice",
};

type CheckboxProps = ComponentProps<typeof HeadlessCheckbox> & {
    size?: keyof typeof sizes;
    color?: keyof typeof colors;
    checked?: boolean;
    onChange?: (value: boolean) => void;
    label?: string | ReactNode;
    reverse?: boolean;
    wrapperClassName?: string;
    error?: string;
};

export default function Checkbox({
    size = "base",
    color = "black",
    checked,
    onChange,
    label,
    reverse,
    wrapperClassName = "",
    error,
    ...rest
}: CheckboxProps) {
    return (
        <div>
            <Field
                className={`flex items-center gap-x-2 ${reverse ? "flex-row-reverse justify-end" : ""} ${wrapperClassName}`}
            >
                <HeadlessCheckbox
                    checked={checked}
                    onChange={onChange}
                    className={`group peer block rounded border bg-white focus:shadow-focus-state shadow-blue-300 ${sizes[size]} ${colors[color]} p-[2px] data-disabled:opacity-50 border-gray-200`}
                    {...rest}
                >
                    <CheckIcon
                        className="stroke-white opacity-0 group-data-checked:opacity-100"
                        strokeWidth={2}
                    />
                </HeadlessCheckbox>
                {label && (
                    <Label className="peer-data-disabled:opacity-50 text-sm shrink">
                        {label}
                    </Label>
                )}
            </Field>
            <Error error={error} />
        </div>
    );
}
